import { lazy } from "react";
import { useSelector } from "react-redux";
import { DialogContent } from "@mui/material";
import { RootState } from "../../../redux/store";

const UserRegisterPageDialog = lazy(() => import("./RegisterUser"));

const dialogsTypesWise: any = {
    "RegisterAs": () => <UserRegisterPageDialog/>,
}

const dialogTypeFullScreen: any = {
}

const UserRegisterPage: React.FC = () => {
    const { type, isFullScreen } = useSelector((state: RootState) => state.dialog);

    return (
        <>
            {
                (isFullScreen && dialogTypeFullScreen[type]?.()) ?
                    (
                        <DialogContent sx={{ height: "100%", margin: 0, padding: 0 }}  > {dialogTypeFullScreen[type]?.() ?? null} </DialogContent>
                    ) : (
                        <>
                            { dialogsTypesWise[type]?.() ?? null }
                        </>
                    )
            }
        </>
    )
}
export default UserRegisterPage;
